import { CSSProperties } from "react";
import Required from "./Required";

interface RequiredTitleProps {
  title: string;
  size?: string;
  titleCSS?: string;
  titleStyle?: CSSProperties;
  className?: string;
}

const RequiredTitle = ({
  title,
  size = "sm",
  titleCSS = "",
  titleStyle,
  className,
}: RequiredTitleProps) => (
  <div className={`d-flex justify-content-between ${className}`}>
    {size === "sm" ? (
      <h5 className={titleCSS} style={titleStyle}>
        {title}
      </h5>
    ) : (
      <h4 className={titleCSS} style={titleStyle}>
        {title}
      </h4>
    )}
    <Required />
  </div>
);

export default RequiredTitle;
